import { motion } from 'motion/react';
import { Box, ChatMessage, Flex, Spinner, Text } from 'pcln-design-system';
import React, { useEffect, useState } from 'react';
import TryAgain from './components/TryAgain';
import { ScrollIntoView } from './ScrollIntoView';
import { StyledLoadingBox } from './StyledLoadingBubble';
import { TravelBotLogoImage } from './TravelBotLogoImage';
/**
 * DialogLoading
 * Three dots loading component
 * @public
 */
export const DialogLoading = props => {
  var _a, _b, _c;
  const [showTryAgain, setShowTryAgain] = useState(false);
  const showEllipsis = !props.streamingText;
  const ellipsisProps = {
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    bg: '#868d95'
  };
  const TIMEOUT = props.timeout || 120000; //120000 = 2 minutes
  const MessageIcon = function Icon() {
    return React.createElement(TravelBotLogoImage, null);
  };
  useEffect(() => {
    // Set a timer to show the TryAgain component after 2 minutes.
    const timeoutId = setTimeout(() => {
      setShowTryAgain(true);
    }, TIMEOUT);
    // Clear timeout if the loading completes or component unmounts
    return () => clearTimeout(timeoutId);
  }, []);
  useEffect(() => {
    if (!showEllipsis) {
      setShowTryAgain(false);
    }
  }, [!props.streamingText]);
  const hasLoadingStatusMessages = Array.isArray(props === null || props === void 0 ? void 0 : props.loadingStatusMessages) && ((_a = props === null || props === void 0 ? void 0 : props.loadingStatusMessages) === null || _a === void 0 ? void 0 : _a.length) > 0;
  const lastStatus = (_b = props.loadingStatusMessages) === null || _b === void 0 ? void 0 : _b[((_c = props.loadingStatusMessages) === null || _c === void 0 ? void 0 : _c.length) - 1];
  return showTryAgain ? React.createElement(ScrollIntoView, null, React.createElement(TryAgain, {
    lastMessage: `DialogLoading - Component (timeout set to ${TIMEOUT}):: ${(props === null || props === void 0 ? void 0 : props.lastMessage) || 'unknown lastMessage'}`
  })) : React.createElement(React.Fragment, null, hasLoadingStatusMessages && React.createElement(ChatMessage, {
    mb: 40,
    Icon: MessageIcon,
    variation: 'initial',
    message: React.createElement(Flex, {
      alignItems: 'center',
      pl: '4px'
    }, React.createElement(Box, {
      width: 24,
      height: 24
    }, React.createElement(Spinner, {
      size: 24
    })), React.createElement(Text, {
      fontSize: 2,
      ml: 2
    }, lastStatus))
  }), (props.streamingText || !hasLoadingStatusMessages && showEllipsis) && React.createElement(ChatMessage, {
    mb: 40,
    Icon: MessageIcon,
    variation: 'initial',
    message: React.createElement(Box, null, props.streamingText && props.streamingText.split('\n').map((c, ci) => React.createElement(Text, {
      fontSize: 2,
      key: `chat-content-${ci}`
    }, c)), showEllipsis && React.createElement(motion.div, null, React.createElement(StyledLoadingBox, {
      mt: 1,
      bg: 'background.light',
      width: '62px',
      height: '32px',
      align: 'center',
      justifyContent: 'space-between'
    }, React.createElement(Box, Object.assign({}, ellipsisProps, {
      id: 'ellipses_1'
    })), React.createElement(Box, Object.assign({}, ellipsisProps, {
      id: 'ellipses_2'
    })), React.createElement(Box, Object.assign({}, ellipsisProps, {
      id: 'ellipses_3'
    })))))
  }));
};